import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import ProfileFieldInput from './ProfileFieldInput';
import { getProfileFieldGridSize } from './constants';
import { getProfileFieldRowState } from './profileFieldGridHelpers';
import {
  memberProfileFieldKey,
  filterProfileFieldsForCartUser,
} from './profileFieldFormUtils';

/**
 * Checkout / cart profile fields keyed by `${userId}-${name}-${profileId}`.
 */
const CheckoutProfileFieldsGrid = ({
  profileFields,
  userId,
  formValues,
  formSubmitted,
  onFieldChange,
  cartData,
  packageProductData,
  isItemMatching,
  fieldErrors,
}) => {
  const fields = filterProfileFieldsForCartUser(
    profileFields,
    userId,
    cartData,
    packageProductData,
    isItemMatching,
  );

  if (!fields.length) {
    return null;
  }

  return fields.map((field) => {
    const formKey = memberProfileFieldKey(userId, field);
    const { displayValue, helperText, hasError } = getProfileFieldRowState(
      field,
      formValues[formKey],
      formSubmitted,
      fieldErrors,
      formKey,
    );

    return (
      <Grid size={getProfileFieldGridSize(field)} key={formKey}>
        <ProfileFieldInput
          field={field}
          value={displayValue}
          onChange={(_field, value) => onFieldChange(formKey, value)}
          error={hasError}
          helperText={helperText}
        />
        <input
          type='hidden'
          name={`${userId}-${field.profile_field_name}`}
          value={field.profile_field_name}
          readOnly
        />
      </Grid>
    );
  });
};

CheckoutProfileFieldsGrid.propTypes = {
  profileFields: PropTypes.array,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  formValues: PropTypes.object,
  formSubmitted: PropTypes.bool,
  onFieldChange: PropTypes.func.isRequired,
  cartData: PropTypes.array,
  packageProductData: PropTypes.array,
  isItemMatching: PropTypes.func.isRequired,
  fieldErrors: PropTypes.object,
};

export default CheckoutProfileFieldsGrid;
